// These are production canonical URLs
export var URLS = /*#__PURE__*/ function(URLS) {
    URLS["ROOT"] = "https://www.deviantart.com";
    // the following are non-node URLs
    URLS["ABOUT"] = "https://www.deviantart.com/about";
    URLS["ACCESSIBILITY_POLICY"] = "https://www.deviantart.com/about/policy/accessibility";
    URLS["ADVERTISE"] = "https://deviantartads.com";
    URLS["CAREERS"] = "https://www.deviantart.com/team/journal/Careers-at-DeviantArt-855261915";
    URLS["CART"] = "https://www.deviantart.com/checkout/";
    URLS["COMMISSIONS"] = "https://www.deviantart.com/commissions";
    URLS["CONTACT"] = "https://www.deviantartsupport.com/en/article/how-do-i-contact-deviantart";
    URLS["COPYRIGHT"] = "https://www.deviantart.com/about/policy/copyright/";
    URLS["COPYRIGHT_POLICY"] = "https://www.deviantartsupport.com/en/article/the-copyright-policy";
    URLS["CORE_MEMBERSHIP"] = "https://www.deviantart.com/core-membership";
    URLS["DEVELOPERS"] = "https://www.deviantart.com/developers";
    URLS["DREAMUP_POLICY"] = "https://www.deviantart.com/about/policy/dreamup/";
    URLS["EARNINGS"] = "https://www.deviantart.com/account/earnings/";
    URLS["EARNINGS_DOWNLOAD"] = "https://www.deviantart.com/account/earnings/download_csv/";
    URLS["ETIQUETTE"] = "https://www.deviantart.com/about/policy/etiquette";
    URLS["FEEDBACK"] = "https://www.deviantartsupport.com/en/eclipse";
    URLS["FORUM"] = "https://www.deviantart.com/forum";
    URLS["GROUPS"] = "https://www.deviantart.com/groups";
    URLS["GROUPS_CREATE"] = "https://www.deviantart.com/groups/create";
    URLS["HELP"] = "https://www.deviantartsupport.com/en";
    URLS["HELP_NEW_TICKET"] = "https://contact.deviantartsupport.com/en";
    URLS["LOGOUT"] = "https://www.deviantart.com/users/logout";
    URLS["MATURE_POLICY"] = "https://www.deviantartsupport.com/en/article/what-is-deviantarts-policy-around-sexual-erotic-and-fetish-themes";
    URLS["MLT"] = "https://www.deviantart.com/morelikethis";
    URLS["NOTES"] = "https://www.deviantart.com/notifications/notes";
    URLS["OAUTH_AUTHORIZE"] = "https://www.deviantart.com/oauth2/authorize";
    URLS["ORDERS"] = "https://www.deviantart.com/account/";
    URLS["POINTS"] = "https://www.deviantart.com/account/points/";
    URLS["ABOUT_POINTS"] = "https://www.deviantartsupport.com/en/article/what-are-points-1749105";
    URLS["POINTS_POLICY"] = "https://www.deviantart.com/about/policy/points/";
    URLS["POLLS"] = "https://www.deviantart.com/polls";
    URLS["PRIVACY"] = "https://www.deviantart.com/about/policy/privacy";
    URLS["SETTINGS"] = "https://www.deviantart.com/settings/identity";
    URLS["SETTINGS_GENERAL"] = "https://www.deviantart.com/settings/general";
    URLS["SETTINGS_BILLING"] = "https://www.deviantart.com/settings/billing_and_payments";
    URLS["SETTINGS_REBILLING"] = "https://www.deviantart.com/settings/rebilling";
    URLS["SETTINGS_PROMOS"] = "https://www.deviantart.com/settings/promos";
    URLS["SETTINGS_BROWSING"] = "https://www.deviantart.com/settings/browsing";
    URLS["SHOP"] = "https://www.deviantart.com/shop";
    URLS["SHOP_ME"] = "https://www.deviantart.com/me/shop";
    URLS["SHOP_TOP_NAV"] = "https://www.deviantart.com/dasellerresources";
    URLS["STASH"] = "https://sta.sh/";
    URLS["STATUS_UPDATES"] = "https://www.deviantart.com/status-updates";
    URLS["SUBMISSION_POLICY"] = "https://www.deviantart.com/about/policy/submission";
    URLS["SUBMIT"] = "https://www.deviantart.com/submit/";
    URLS["SUPPORT"] = "https://www.deviantart.com/contact-us";
    URLS["STUDIO"] = "https://www.deviantart.com/studio";
    URLS["SUBMIT_MURO"] = "https://www.deviantart.com/muro/";
    URLS["TAG"] = "https://www.deviantart.com/tag";
    URLS["TOS"] = "https://www.deviantart.com/about/policy/service";
    URLS["COOKIES"] = "https://www.deviantart.com/settings/cookies";
    URLS["WATCHING"] = "https://www.deviantart.com/watching/";
    URLS["CHAT_HOME"] = "https://www.deviantart.com/chat";
    URLS["CDN"] = "https://st.deviantart.net";
    URLS["ART_STORE"] = "https://www.popup-art.shop/";
    URLS["DMCA"] = "https://contact.deviantartsupport.com/en?subOptionId=I-am-the-Copyright-holder.41656";
    URLS["DMCA_COUNTER"] = "https://contact.deviantartsupport.com/en?subOptionId=I%27d-like-to-file-a-counter-DMCA61640";
    URLS["CUSTOMER_DASHBOARD"] = "https://www.deviantart.com/account/customers";
    URLS["CHECKOUT_ERRORS"] = "https://www.deviantartsupport.com/en/article/why-am-i-getting-an-issue-notification-when-i-try-to-purchase";
    URLS["EXCLUSIVES_HOWTO"] = "https://www.deviantartsupport.com/kb/en/article/how-do-i-buy-an-adoptable-or-exclusive";
    URLS["PROTECT"] = "https://www.deviantartprotect.com/";
    URLS["TEAM"] = "https://www.deviantart.com/team";
    URLS["COMMUNITY"] = "https://www.deviantart.com/community";
    URLS["APP_PLAYSTORE_URL"] = "https://play.google.com/store/apps/details?id=com.deviantart.android.damobile";
    URLS["BETA_TESTING"] = "https://www.deviantart.com/team/journal/Become-a-Beta-Tester-on-DeviantArt-983449642";
    // Social links
    URLS["DEVIANTART_INSTAGRAM"] = "https://www.instagram.com/deviantart/";
    URLS["DEVIANTART_FACEBOOK"] = "https://www.facebook.com/deviantart/";
    URLS["DEVIANTART_TWITTER"] = "https://twitter.com/DeviantArt";
    return URLS;
}({});
export var PROJECTS = /*#__PURE__*/ function(PROJECTS) {
    PROJECTS["BROWSE"] = "BROWSE";
    PROJECTS["MESSAGECENTRE"] = "MESSAGECENTRE";
    PROJECTS["PROFILE"] = "PROFILE";
    PROJECTS["DEVIATION"] = "DEVIATION";
    PROJECTS["COMMENTS"] = "COMMENTS";
    PROJECTS["SISU"] = "SISU";
    PROJECTS["PONIES"] = "PONIES";
    PROJECTS["CHAT"] = "CHAT";
    PROJECTS["EDITOR"] = "EDITOR";
    PROJECTS["FEEDBACK"] = "FEEDBACK";
    PROJECTS["STASH"] = "STASH";
    return PROJECTS;
}({});
export var USER_PROFILE_SECTION_PATHS = /*#__PURE__*/ function(USER_PROFILE_SECTION_PATHS) {
    USER_PROFILE_SECTION_PATHS["HOME"] = "";
    USER_PROFILE_SECTION_PATHS["ABOUT"] = "about";
    USER_PROFILE_SECTION_PATHS["GALLERY"] = "gallery";
    USER_PROFILE_SECTION_PATHS["SHOP"] = "shop";
    USER_PROFILE_SECTION_PATHS["FAVOURITES"] = "favourites";
    USER_PROFILE_SECTION_PATHS["PRIVATE_COLLECTIONS"] = "private-collections";
    USER_PROFILE_SECTION_PATHS["POSTS"] = "posts";
    USER_PROFILE_SECTION_PATHS["STATS"] = "stats";
    USER_PROFILE_SECTION_PATHS["SUBSCRIPTIONS"] = "subscriptions";
    USER_PROFILE_SECTION_PATHS["BACKROOM"] = "backroom";
    USER_PROFILE_SECTION_PATHS["EXCLUSIVES"] = "exclusives";
    return USER_PROFILE_SECTION_PATHS;
}({});
export var USER_PROFILE_SHOP_SUB_PATHS = /*#__PURE__*/ function(USER_PROFILE_SHOP_SUB_PATHS) {
    USER_PROFILE_SHOP_SUB_PATHS["ALL"] = "";
    USER_PROFILE_SHOP_SUB_PATHS["ADOPTABLES"] = "adoptables";
    USER_PROFILE_SHOP_SUB_PATHS["EXCLUSIVES"] = "exclusives";
    USER_PROFILE_SHOP_SUB_PATHS["COMMISSIONS"] = "commissions";
    USER_PROFILE_SHOP_SUB_PATHS["PREMIUM_CONTENT"] = "premium_content";
    USER_PROFILE_SHOP_SUB_PATHS["PREMIUM_FOLDERS"] = "premium_folders";
    return USER_PROFILE_SHOP_SUB_PATHS;
}({});
export var USER_PROFILE_POSTS_SUB_PATHS = /*#__PURE__*/ function(USER_PROFILE_POSTS_SUB_PATHS) {
    USER_PROFILE_POSTS_SUB_PATHS["ALL"] = "";
    USER_PROFILE_POSTS_SUB_PATHS["JOURNALS"] = "journals";
    USER_PROFILE_POSTS_SUB_PATHS["STATUSES"] = "statuses";
    USER_PROFILE_POSTS_SUB_PATHS["POLLS"] = "polls";
    USER_PROFILE_POSTS_SUB_PATHS["DRAFTS"] = "drafts";
    return USER_PROFILE_POSTS_SUB_PATHS;
}({});
export var USER_PROFILE_BACKROOM_SECTIONS = /*#__PURE__*/ function(USER_PROFILE_BACKROOM_SECTIONS) {
    USER_PROFILE_BACKROOM_SECTIONS["ROOT"] = "";
    USER_PROFILE_BACKROOM_SECTIONS["NOTES"] = "notes";
    USER_PROFILE_BACKROOM_SECTIONS["ACTION_LOG"] = "actionlog";
    USER_PROFILE_BACKROOM_SECTIONS["MESSAGE_LOG"] = "messagelog";
    USER_PROFILE_BACKROOM_SECTIONS["ROSTER"] = "roster";
    return USER_PROFILE_BACKROOM_SECTIONS;
}({});
export var DEVIATION_PATHS = /*#__PURE__*/ function(DEVIATION_PATHS) {
    DEVIATION_PATHS["DEVIATION"] = "art";
    DEVIATION_PATHS["JOURNAL"] = "journal";
    DEVIATION_PATHS["COMMISSION"] = "commission";
    DEVIATION_PATHS["STATUS"] = "status-update";
    DEVIATION_PATHS["POLL"] = "poll";
    DEVIATION_PATHS["TIER"] = "tier";
    return DEVIATION_PATHS;
}({});
export var CONTACT_PAGE_ANCHOR_JUMP_POINTS = /*#__PURE__*/ function(CONTACT_PAGE_ANCHOR_JUMP_POINTS) {
    CONTACT_PAGE_ANCHOR_JUMP_POINTS["DRILLDOWN"] = "drilldown";
    CONTACT_PAGE_ANCHOR_JUMP_POINTS["ISSUE_RESPONSE"] = "issue-response";
    CONTACT_PAGE_ANCHOR_JUMP_POINTS["FORM"] = "form";
    return CONTACT_PAGE_ANCHOR_JUMP_POINTS;
}({});
export var SHOP_PATHS = /*#__PURE__*/ function(SHOP_PATHS) {
    SHOP_PATHS["ADOPTABLES"] = "adoptables";
    SHOP_PATHS["EXCLUSIVES"] = "exclusives";
    SHOP_PATHS["DOWNLOADS"] = "downloads";
    SHOP_PATHS["COMMISSIONS"] = "commissions";
    SHOP_PATHS["SUBSCRIPTIONS"] = "subscriptions";
    return SHOP_PATHS;
}({});
export var CHECKOUT_IDS = /*#__PURE__*/ function(CHECKOUT_IDS) {
    CHECKOUT_IDS[CHECKOUT_IDS["CAKE"] = 150647560] = "CAKE";
    return CHECKOUT_IDS;
}({});
export var DEVIATION_PAGE_LANDING_ACTION = /*#__PURE__*/ function(DEVIATION_PAGE_LANDING_ACTION) {
    DEVIATION_PAGE_LANDING_ACTION["ADOPTABLE_BUY_IT_NOW"] = "adoptable-buy-now";
    DEVIATION_PAGE_LANDING_ACTION["ADOPTABLE_MAKE_OFFER"] = "adoptable-make-offer";
    return DEVIATION_PAGE_LANDING_ACTION;
}({});

//# sourceMappingURL=constants.js.map